import moment from 'moment';
import download from 'downloadjs';

const hasOwn = Object.prototype.hasOwnProperty;

// 暂停
export const sleep = async (delay: number) => new Promise((resolve) => setTimeout(resolve, delay * 1000));

// 格式化日期
export const format = (dateStr: string | Date | DOMTimeStamp, showTime = false) => {
  const fmt = showTime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
  return dateStr ? moment(dateStr).format(fmt) : '';
};

// 将 Bit 单位转换为 KB, MB, GB
export const formatFileSize = (value: number, toFixed = 3) => {
  const kb = Math.pow(1024, 1);
  const mb = Math.pow(1024, 2);
  const gb = Math.pow(1024, 3);
  const tb = Math.pow(1024, 4);
  const pb = Math.pow(1024, 5);
  switch (true) {
    case value > pb:
      return `${(value / pb).toFixed(toFixed)}PB`;
    case value > tb:
      return `${(value / tb).toFixed(toFixed)}TB`;
    case value > gb:
      return `${(value / gb).toFixed(toFixed)}GB`;
    case value > mb:
      return `${(value / mb).toFixed(toFixed)}MB`;
    case value > kb:
      return `${(value / kb).toFixed(toFixed)}KB`;
    default:
      return `${value}B`;
  }
};

// 对象转为querystring
export const qs = (obj: Record<string, any>) => {
  return Object.keys(obj).reduce((acc, key) => {
    const str = `${key}=${obj[key]}`;
    return acc + (acc ? `&${str}` : str);
  }, '');
};

// 对象里的字符串类型字段去空格
export const trims = (obj: Record<string, any>) => {
  const result: Record<string, any> = {};
  for (const key in obj) {
    if (hasOwn.call(obj, key)) {
      const val = obj[key];
      result[key] = typeof val === 'string' ? val.trim() : val;
    }
  }
  return result;
};

// 下载二进制文件
export const downloadFile = (blobData: Blob, filename = '文件', ext = '.xlsx') => {
  let link: any = document.createElement('a');
  if ('download' in link) {
    const href = window.URL.createObjectURL(blobData);
    link.download = filename + ext;
    link.href = href;
    link.click();
    link = null;
  } else {
    alert('该浏览器不支持下载，请升级浏览器');
  }
};

// 通过 url 下载或预览文件
export const downloadOrPreview = (url: string, target = '') => {
  let link: any = document.createElement('a');
  if ('download' in link) {
    link.href = url;
    link.target = target;
    link.click();
    link = null;
  } else {
    alert('该浏览器不支持下载，请升级浏览器');
  }
};

// 通过 xhr 下载
export const downloadLink = (url: string, ext?: string) => {
  return new Promise((resolve, reject) => {
    const urlStr = decodeURIComponent(url || '').split('?')[0];
    const fileFullName = urlStr.slice(urlStr.lastIndexOf('/') + 1);
    const lastExtIndex = fileFullName.lastIndexOf('.');
    const fileName = lastExtIndex === -1 ? fileFullName : fileFullName.slice(0, lastExtIndex);
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      const rename = ext ? `${fileName}${ext}` : fileFullName;
      download(xhr.response, rename);
      resolve({ fileName: rename });
    };
    xhr.onerror = () => {
      reject('下载失败');
    };
    xhr.send();
  });
};

/**
 * 乘法函数，用来得到精确的乘法结果
 * 说明：js 的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果
 * 比如：0.1 * 0.2 会出现错误的结果
 */
export const accMul = (num1: number, num2: number) => {
  const str1 = num1.toString();
  const str2 = num2.toString();
  const int1 = str1.replace('.', '');
  const int2 = str2.replace('.', '');
  const len1 = str1.split('.')[1]?.length || 0;
  const len2 = str2.split('.')[1]?.length || 0;
  return Number(int1) * Number(int2) / Math.pow(10, len1 + len2);
};
